import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

const originalError = console.error;
console.error = (...args) => {
  const msg = args[0];

  if (
    typeof msg === 'string' &&
    msg.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    // 이 경고만 무시
    return;
  }

  // 나머지 에러는 원래대로 출력
  originalError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);


// index.js 같은 곳


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
